<div
  id="Area-Basket"
  class="ArrayFilter"
  *ngIf="{
    channelSelected: channelSelected$ | async
  } as data"
>
  <cng-basket-channel-selection></cng-basket-channel-selection>
  <!-- MAIL -->
  <cng-agent-mail-basket *ngIf="data.channelSelected | mapper: isChannel:ChannelType.MAIL" class="panel"></cng-agent-mail-basket>
  <!-- VISIO -->
  <cng-agent-visio-basket *ngIf="data.channelSelected | mapper: isChannel:ChannelType.VISIO" class="panel"></cng-agent-visio-basket>
</div>
